import { z } from 'zod';
import { productBrandIndicationNamedSchema } from './product-brand-indications.js';

export const strategicImperativeSchema = z.object({
  title: z.string(),
  description: z.string(),
  subStrategies: z.array(z.string()),
});

export const brandContextResolutionModeSchema = z.enum(['brand_derived', 'user_derived']);
export type BrandContextResolutionMode = z.infer<typeof brandContextResolutionModeSchema>;

export const brandLookupSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  displayName: z.string().nullable(),
});

export const brandDrugClassProductBrandMappingSchema = z.object({
  drugClass: brandLookupSchema,
  productBrands: z.array(brandLookupSchema),
});

export const productBrandIndicationMappingSchema = productBrandIndicationNamedSchema;

export const brandDetailsSchema = z.object({
  id: z.number(),
  identifier: z.string(),
  displayName: z.string(),
  name: z.string(),
  brandContextResolutionMode: brandContextResolutionModeSchema,
  genericNames: z.array(z.string()),
  // description: Remirror.RemirrorSchema.RootNode,
  synonyms: z.array(z.string()),
  strategicImperatives: z.array(strategicImperativeSchema),
  salesDirections: z.string().array(),
  munTargets: z.string().array(),
  access: z.string().optional(),
  groupId: z.number(),
  indication: brandLookupSchema.nullable().optional(),
  therapeuticArea: brandLookupSchema.nullable().optional(),
  brandsToProductBrands: z.array(productBrandIndicationMappingSchema),
  competitors: brandLookupSchema.array().optional(),
  drugClasses: brandLookupSchema.array().optional(),
  genericDrugs: brandLookupSchema.array().optional(),
  drugClassProductBrandMappings: z.array(brandDrugClassProductBrandMappingSchema).optional(),
});
export type BrandDetails = z.infer<typeof brandDetailsSchema>;
